module.exports = __webpack_public_path__ + "static/media/facility-report-banner-icno.0b21bce3.svg";